import { render, staticRenderFns } from "./GHSWarningLabel.vue?vue&type=template&id=44bec67a&scoped=true"
import script from "./GHSWarningLabel.vue?vue&type=script&lang=js"
export * from "./GHSWarningLabel.vue?vue&type=script&lang=js"
import style0 from "./GHSWarningLabel.vue?vue&type=style&index=0&id=44bec67a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bec67a",
  null
  
)

export default component.exports